/**
 * Created by wangmeng on 2017/7/13.
 */
import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {HttpModule, JsonpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {Title} from '@angular/platform-browser';

import {AuthService, UserServiceConfig} from './auth.service';
import {AuthGuard} from './auth-guard.service';
import {WxService} from './wx.service';

@NgModule({
  imports: [CommonModule, HttpModule, FormsModule, JsonpModule, RouterModule],
  declarations: [],
  exports: [],
  providers: [Title, AuthService, AuthGuard, WxService]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import is in ths AppModule only.');
    }
  }

  static forRoot(config: UserServiceConfig): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        {provide: UserServiceConfig, useValue: config}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts